import { render, staticRenderFns } from "./StudentSellingGoods.vue?vue&type=template&id=79b81540&scoped=true&"
import script from "./StudentSellingGoods.vue?vue&type=script&lang=js&"
export * from "./StudentSellingGoods.vue?vue&type=script&lang=js&"
import style0 from "./StudentSellingGoods.vue?vue&type=style&index=0&id=79b81540&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b81540",
  null
  
)

export default component.exports